let minx = {
  data() {
    return {
      userTypeMap: {
        '1': '申请人',
        '2': '被申请人',
        '3': '申请人代理人',
        '4': '被申请人代理人',
      },
      userTypeList: [
        { value: '1', label: '申请人' },
        { value: '2', label: '被申请人' },
        { value: '3', label: '申请人代理人' },
        { value: '4', label: '被申请人代理人' }
      ]
    }
  },
  methods: {
    // 用户类型 1 原告 2 被告 3 原告代理人 4 被告代理人
    computedUserType(userType) {
      if (!userType) { return '--' }
      let str = this.userTypeMap[String(userType)]
      if (str) {
        return str
      } else {
        return userType
      }
    },
    formatePhone(phone) {
      if (!phone) { return '--' }
      return phone.replace(/^(1[2-9][0-9])([0-9]{4})([0-9]{4})$/, '$1****$3')
    }
  }
}

export default minx;